/**
 * Centralized React Query keys for custom surveys
 * This ensures consistent cache management across the app
 */

export const customSurveyKeys = {
  all: ['custom-surveys'] as const,
  lists: () => [...customSurveyKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...customSurveyKeys.lists(), { filters }] as const,
  byTeam: (teamId: number) => [...customSurveyKeys.lists(), 'team', teamId] as const,
  details: () => [...customSurveyKeys.all, 'detail'] as const,
  detail: (id: number) => [...customSurveyKeys.details(), id] as const,
  detailByUuid: (uuid: string) => [...customSurveyKeys.details(), 'uuid', uuid] as const,
  results: (id: number) => [...customSurveyKeys.detail(id), 'results'] as const,
};

export const customSurveyTemplateKeys = {
  all: ['custom-survey-templates'] as const,
  lists: () => [...customSurveyTemplateKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...customSurveyTemplateKeys.lists(), { filters }] as const,
  details: () => [...customSurveyTemplateKeys.all, 'detail'] as const,
  detail: (id: number) => [...customSurveyTemplateKeys.details(), id] as const,
  trends: (id: number) => [...customSurveyTemplateKeys.detail(id), 'trends'] as const,
};
